import React from 'react';
import {
    IonButton,
    IonContent,
    IonHeader,
    IonPage,
    IonIcon,
    IonToolbar,
    IonGrid,
    IonRow,
    IonCol,
    IonLabel,
    IonCard,
    IonCardHeader,
    IonCardContent,
    IonTitle,
    IonLoading
} from '@ionic/react';
import { ticket } from 'ionicons/icons';
import DodCopy from "./devTools/DodCopy";

const DevTools: React.FC<any> = () => {
    const DEFAULT_LOADING_MESSAGE: string = 'Please wait...';
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [loadingMessage, setLoadingMessage] = React.useState<string>(DEFAULT_LOADING_MESSAGE);

    return (
        <IonPage>

            <IonHeader>
                <IonToolbar>
                    <IonTitle>Dev Tools</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonLoading isOpen={isLoading} message={loadingMessage}/>
            <IonContent fullscreen className="dev-tools" style={{padding:'10px'}}>
                <p>Tools for use by the IT department only.</p>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonCard>
                                <IonCardHeader>
                                    <IonTitle>
                                        Asana DOD Copy
                                    </IonTitle>
                                </IonCardHeader>
                                <IonCardContent>
                                    Copy DOD tasks and subtasks to another task
                                    <p style={{textAlign: 'right', marginTop:'10px'}}>
                                        <IonButton href="/dev-tools/dod-copy">

                                            <IonIcon ios={ticket} md={ticket}></IonIcon>
                                            <IonLabel> Asana DOD Copy</IonLabel>
                                        </IonButton>
                                    </p>
                                </IonCardContent>

                            </IonCard>

                        </IonCol>
                        <IonCol>

                        </IonCol>
                        <IonCol>

                        </IonCol>
                        <IonCol>

                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default DevTools;